import { Directive, Input } from '@angular/core';
import { IContactPersonResponse } from '../../models';

@Directive()
export class EmergencyContactBaseComponent {
  @Input() contact: IContactPersonResponse;
}
